


import TiwiMixin from '../mixins/TiwiMixin'

export default {
  mixins: [TiwiMixin],
  props: {
    relatedId: {
      required: true,
      //type: Number,
    },
    relatedType: {
      //type: Number,
      required: false,
      default: 'post'
    },
    count: {
      //type: Number,
      required: false,
      default: 0
    },
    iconClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      active: false,
      current_count: 0,
    }
  },
  mounted: function () {
    // Eseguito al mount

    this.active = false; //
    this.current_count = this.count;

    if (this.user_activity) {
      this.active = this.user_activity.LIKE?.[this.relatedType]?.includes(this.relatedId);
    }

  },
  computed: {
    currentCountAdjusted: function () {
      return parseInt(this.current_count);
      //return parseInt(this.current_count) + this.getHashedNumber('LIKE', this.relatedId, 100);
    }
  },
  methods: {
    toggleActive: function () {

      if (!this.user?.ID)
        return;

      this.active = !this.active;

      var self = this;
      self.setLoading(true);

      var post_data = { type: 'LIKE', related_id: this.relatedId, related_type: this.relatedType, active: this.active };


      this.api.post('user-event/toggle', post_data)
        .then((response) => {

          if (response.data.success) {
            this.current_count += (this.active ? 1 : -1)
          }
          else {
            self.toast.error(response.data.message);

          }

        })
        .catch((error) => {
          self.toast.error('Errore nella richiesta');
        })
        .finally(() => self.setLoading(false))
    }
  },
  watch: {
    user_activity: function (new_val, old_val) {
      if (new_val && new_val.LIKE && new_val.LIKE?.[this.relatedType]) {
        this.active = new_val.LIKE?.[this.relatedType].includes(this.relatedId);
      }
    },
    /*
    statistics: function (new_val, old_val) {
      if (new_val && new_val.LIKE && new_val.LIKE[this.relatedType] && new_val.LIKE[this.relatedType][this.relatedId])
        this.current_count = new_val.LIKE[this.relatedType][this.relatedId];

    },
    */
  }
}
